import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
const ContactUsDetails = () => {

    const { id } = useParams();
    const [data, setData] = useState([]);
    const [updateData, setupdateData] = useState([]);
    useEffect(() => {
        fetch(`https://api.wlfmobile.com/api/admin/subscriber/manager/contact/us/view/by/id/${id}`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
            })
    }, [updateData])



    const [dataVulue, setDataVulue] = useState({});
    const refSubmitDis = useRef();


    const handleSubmitData = event => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        const config = {
            headers: {
                'content-type': 'application/json',
            }
        };
        axios.post(`https://api.wlfmobile.com/api/admin/subscriber/manager/contact/us/email/send/${id}`, dataVulue, config)
            .then(response => {
                event.target.reset();
                toast.success(`${response?.data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setupdateData(response?.data);
                refSubmitDis.current.removeAttribute("disabled");
            }).catch((error) => {
                refSubmitDis.current.removeAttribute("disabled");
            });

    }

    const handleInputBlur = event => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...dataVulue };
        newData[field] = value;
        setDataVulue(newData);
    }



    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title"> {data?.name}  requested contact</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
                </div>
            </div>

            <div className="row mb-none-30 justify-content-center">
                <div className="col-xl-5 col-md-6 mb-30">
                    <div className="card b-radius--10 overflow-hidden box--shadow1">
                        <div className="card-body">
                            <h5 className="mb-20 text-muted">Contact Us

                            </h5>

                            <div className="row">
                                <div className="col-lg-12 col-md-12 mb-30">
                                    <div className="card">
                                        <div className="card-body">


                                            <ul className="list-group">
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    Full Name                            <span className="fw-bold">{data?.name} </span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    Email                            <span className="fw-bold">{data?.email} </span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    Phone Number                            <span className="fw-bold">{data?.phone} </span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between align-items-center">
                                                    Status

                                                    {data.status === 1 ?
                                                        <span className="badge badge--success text-success">Send Message</span>
                                                        : ''}
                                                    {data.status === 0 ?
                                                        <span className="badge badge--danger text-danger">Pending</span>
                                                        : ''}

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-xl-7 col-md-6 mb-30">
                    <div className="card b-radius--10 overflow-hidden box--shadow1">
                        <div className="card-body">
                            <h5 className="card-title mb-50 border-bottom pb-2"> Details</h5>

                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <h6>Message</h6>
                                    <p>{data?.message}</p>

                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12">

                                    {data?.status === 0
                                        ?

                                        <form onSubmit={handleSubmitData}>
                                            <div className="row">
                                                <div className=" col-md-12 ">

                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">Subject</label>
                                                        <input type="text" className="form-control" name="subject" onBlur={handleInputBlur} placeholder='subject' required  id="heading"  />
                                                    </div>

                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="heading" className="required">Message</label>
                                                        <textarea name='message' onBlur={handleInputBlur} required></textarea>
                                                    </div>
                                                </div>


                                            </div>


                                            <div className="form-group">
                                                <button ref={refSubmitDis} type="submit" className="btn btn-primary w-100 h-45">Submit</button>
                                            </div>
                                        </form>

                                        :
                                        ""
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUsDetails;